export const CHANGE_CAPTCHA_VALUE = '@@b2b_portal_ui/captcha/CHANGE_CAPTCHA_VALUE';
export const HIDE_CAPTCHA = '@@b2b_portal_ui/captcha/HIDE_CAPTCHA';
export const REQUEST_CAPTCHA = '@@b2b_portal_ui/captcha/REQUEST_CAPTCHA';
export const SHOW_CAPTCHA = '@@b2b_portal_ui/captcha/SHOW_CAPTCHA';
export const SET_IMAGE_CAPTCHA = '@@b2b_portal_ui/captcha/SET_IMAGE_CAPTCHA';
export const REQUEST_CAPTCHA_FAILED = '@@b2b_portal_ui/captcha/REQUEST_CAPTCHA_FAILED';
